import React from "react";
import { Box } from "grommet";
export var Container = function Container(_ref) {
  var children = _ref.children,
    overflow = _ref.overflow;
  return /*#__PURE__*/ React.createElement(
    Box,
    {
      width: "1268px",
      overflow: overflow ? "hidden" : "unset",
      margin: {
        horizontal: "auto",
      },
      pad: {
        horizontal: "medium",
      },
    },
    children
  );
};
